import React from 'react'

export const CardIcon = () => (
	<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="40" height="40" rx="3" fill="white" />
		<path d="M9 23V13H24C27.3137 13 30 15.6863 30 19V27H13C10.7909 27 9 25.2091 9 23Z" fill="#85ADFF" />
		<path d="M20.375 27L24.225 13H26C28.2091 13 30 14.7909 30 17V27H20.375Z" fill="#545563" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M14.1142 14.75H12.9482V16.5635L10.9082 16.5635V17.6006H12.9482V19.4167H14.1142V17.6006H16.1552V16.5635L14.1142 16.5635V14.75Z"
			fill="white"
		/>
	</svg>
)
